var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-5 display-3"},[_vm._v(" Pups")]),_c('Koppel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }